import { createReducer, on } from '@ngrx/store';

import { IOptions } from '@shared';
import { addAdminType, loadAdminTypeSuccess, removeAdminType, updateAdminType } from './adminType.actions';

export interface AdminTypeState {
  adminType: IOptions[];
}

export const initialState: AdminTypeState = {
  adminType: [],
};
const _adminTypeReducer = createReducer(
  initialState,
  on(loadAdminTypeSuccess, (state, { adminType }) => ({ ...state, adminType })),
  on(addAdminType, (state, { adminType }) => ({
    ...state,
    adminType: [...state.adminType, adminType],
  })),
  on(removeAdminType, (state, { adminTypeId }) => ({
    ...state,
    adminType: state.adminType.filter((adminType) => adminType._id !== adminTypeId),
  })),
  on(updateAdminType, (state, { adminType }) => ({
    ...state,
    adminType: state.adminType.map((adminTypeItem) => {
      if (adminTypeItem._id === adminType._id) {
        return { ...adminType };
      } else {
        return adminTypeItem;
      }
    }),
  })),
);

export function adminTypeReducer(state: AdminTypeState | undefined, action: any) {
  return _adminTypeReducer(state, action);
}
